import { useState } from 'react';
import { Tooltip } from './Tooltip';
import { OrderBulkUpdateProps, OrderStatus } from '../interface/interface';

export default function OrderBulkUpdateButton(props: OrderBulkUpdateProps) {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  return (
    <div className="relative">
      <div
        className="h-full"
        onMouseEnter={() => {
          if (
            props?.orderBulkUpdate &&
            props.orderBulkUpdate.state.length > 1
          ) {
            setShowTooltip(true);
          }
        }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <button
          className={`ml-4 text-xs border border-secondary-pink-600 rounded font-semibold text-secondary-pink-600 
                      bg-white px-3 py-2 hover:bg-secondary-pink-600 hover:text-white 
                      ${
                        props?.orderBulkUpdate &&
                        (props.orderBulkUpdate.state.length > 1 ||
                          (props?.orderBulkUpdate.state.length &&
                            [
                              OrderStatus.DISPENSING,
                              OrderStatus.DISPENSED,
                            ].includes(
                              props.orderBulkUpdate.state[0]
                                ?.name as OrderStatus,
                            ) &&
                            'opacity-50 cursor-not-allowed'))
                      }`}
          disabled={
            props?.orderBulkUpdate?.state &&
            (props?.orderBulkUpdate.state?.length > 1 ||
              [OrderStatus.DISPENSING, OrderStatus.DISPENSED].includes(
                props.orderBulkUpdate.state[0]?.name as OrderStatus,
              ))
          }
          onClick={() => {
            if (props?.orderBulkUpdate) props?.orderBulkUpdate.action();
          }}
        >
          Bulk Update
        </button>
      </div>
      {showTooltip && (
        <Tooltip
          text={
            'Please select only one status to enable bulk actions on the All Orders list.'
          }
          className="z-50 left-0 -top-10"
        />
      )}
    </div>
  );
}
